import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BillingUser } from "../types";

export const getBillingUserRequest = (
  billingProfileId: string,
  billingUserId: string
) => {
  return apiProxyRequest<BillingUser>(
    `/billing/profiles/${billingProfileId}/users/${billingUserId}`
  );
};
